import { NgRedux } from '@angular-redux/store';
import { Injectable, NgZone } from '@angular/core';

import { IAppState } from '../store/IAppState';
import { ActionKeys } from './action.keys';
import { QuickFilter } from './models/pb-screen.interface';
import { PlanningBlock } from './models/planning-block/planning-block.interface';
import { Column } from './models/application.user.interface';
import { OrderLine } from './models/order-line/orderLine.interface';

import { ChannelEventFactory, ChannelEvent } from "../pb-screen/services/channel.event.factory";
import { SignalrBroadcaster } from "../pb-screen/helpers/signalr.broadcaster";
import { ChannelService } from "../pb-screen/services/channel.service";
import { PbScreenService } from './services/pb-screen.service';
import { AdvancedFilterGroup } from '../shared/components/filter-line/filter-line.interface';
import { ConfirmDialogService } from '../shared/components/confirm-dialog/confirm-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PbActions extends SignalrBroadcaster {


  constructor(
    ngRedux: NgRedux<IAppState>,
    channelEventFactory: ChannelEventFactory,
    channelService: ChannelService,
    private readonly pbService: PbScreenService,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly translate: TranslateService,
    private readonly ngZone: NgZone

) {
    super(ngRedux, channelEventFactory, channelService);
}

  setReuseCandidates(candidates: PlanningBlock[]){
    super.dispatchAction({
      type: ActionKeys.SET_REUSE_CANDIDATES,
      candidates
    });
  }
  
  setSelectedPlanningBlocks(selectedPlanningBlocks: PlanningBlock[], transmitAction: boolean = true) {

    super.dispatchAction({
      type: ActionKeys.SET_SELECTED_PLANNING_BLOCKS,
      selectedPlanningBlocks , 
      selectedTransportOrders : []
    });


    if(transmitAction) {
   var sharedSelectedPlanningBlocks =  this.ngRedux.getState().sharedSelectedPlanningBlocks;
   var localSelecteddPlanningBlocsk: PlanningBlock[] ;
   if(sharedSelectedPlanningBlocks.length > 0)
      localSelecteddPlanningBlocsk =  selectedPlanningBlocks.filter( pb => sharedSelectedPlanningBlocks.findIndex(sPb=> sPb.id == pb.id) < 0 ) ;
    else
      localSelecteddPlanningBlocsk = selectedPlanningBlocks ;
    super.TransmitAction({
      type: ActionKeys.SET_Shared_SELECTED_PLANNING_BLOCKS,
       selectedPlanningBlocks: localSelecteddPlanningBlocsk,
       selectedTransportOrders : []
    }) ;
  }
  }

  setSharedSelectedPlanningBlocks(sharedSelectedPlanningBlock: PlanningBlock[]) {

  var appState =  this.ngRedux.getState();

   var selectedPlanningBlocks = appState.selectedPlanningBlocks;
   var sharedSelectedPlanningBlocksPrev = appState.sharedSelectedPlanningBlocks;

   var localSelecteddPlanningBlocsk: PlanningBlock[] ;
   if(sharedSelectedPlanningBlocksPrev.length > 0)
      localSelecteddPlanningBlocsk =  selectedPlanningBlocks.filter( pb => sharedSelectedPlanningBlocksPrev.findIndex(sPb=> sPb.id == pb.id) < 0 ) ;
    else
      localSelecteddPlanningBlocsk = selectedPlanningBlocks ;


      super.dispatchAction({
        type: ActionKeys.SET_SELECTED_PLANNING_BLOCKS,
        selectedPlanningBlocks: localSelecteddPlanningBlocsk,
        
       selectedTransportOrders : []
      });



    super.dispatchAction({
      type: ActionKeys.SET_Shared_SELECTED_PLANNING_BLOCKS,
       selectedPlanningBlocks: sharedSelectedPlanningBlock,
       selectedTransportOrders : []
    }) ;

    super.dispatchAction({
      type: ActionKeys.SET_SELECTED_TRANSPORT_ORDERS,
      selectedTransportOrders : []
    });

 }


  public getPlanningBlocks(planningBlocks: PlanningBlock[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.REQUEST_PLANNINGBLOCKS_SUCCESS,
      planningBlocks
    });
  }

  public applyQuickFilter(quickFilter: QuickFilter) {
    this.ngRedux.dispatch({
      type: ActionKeys.APPLY_QUICK_FILTER,
      quickFilter
    });
  }

  public resetQuickFilter(quickFilter?: QuickFilter) {
    this.ngRedux.dispatch({
      type: ActionKeys.RESET_QUICK_FILTER,
      quickFilter
    });
  }

  public resetPlanningBlocks() {
    this.ngRedux.dispatch({
      type: ActionKeys.RESET_PLANNINGBLOCKS,
    });
  }

  public setProcessedDisplayState(processedDisplayState: boolean) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_PROCESSED_DISPLAY_STATE,
      processedDisplayState
    });
  }
  public setImportantDisplayState(importantDisplayState: boolean) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_IMPORTANT_DISPLAY_STATE,
      importantDisplayState
    });
  }

  public setSelectedDisplayState(selectedDisplayState: boolean) {
    this.ngRedux.dispatch({
      type : ActionKeys.SET_SELECTED_DISPLAY_STATE ,
      selectedDisplayState
    })
  }
  public applyGlobalFilter(searchText: string) {
    this.ngRedux.dispatch({
      type: ActionKeys.APPLY_GLOBAL_FILTER,
      searchText
    });
  }

  public applyAdvancedFilter(filterItems: AdvancedFilterGroup): void {
    this.ngRedux.dispatch({
      type: ActionKeys.APPLY_ADVANCED_FILTER,
      filterItems,
    });
  }

  public resetAdvancedFilter(filterItems: AdvancedFilterGroup) {
    this.ngRedux.dispatch({
      type: ActionKeys.RESET_ADVANCED_FILTER,
      filterItems,
    });
  }

  public updateSessionColumns(columns: Column[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.UPDATE_SESSION_COLUMNS,
      columns: columns
    });
  }


  public setActionBarStates(actionBarStates) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_ACTION_BAR_STATES,
      actionBarStates: actionBarStates,
    });
  }

  public resetActionBarStates() {
    this.ngRedux.dispatch({
      type: ActionKeys.RESET_ACTION_BAR_STATES,
    });
  }

  public setDateInterval(startDate: number, endDate: number) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_DATE_INTERVAL,
      startDate: startDate,
      endDate: endDate,
    });
  }

  public updatePlanningBlocksDisplay(updatedPlanningBlocks: PlanningBlock[], transmitAction:boolean = false) {
    if(transmitAction){
      super.dispatchAndTransmitAction({
        type: ActionKeys.UPDATE_PLANNINGBLOCKS_DISPLAY,
        planningBlocks: updatedPlanningBlocks
      } );
    }
    else {
    this.ngRedux.dispatch({
      type: ActionKeys.UPDATE_PLANNINGBLOCKS_DISPLAY,
      planningBlocks: updatedPlanningBlocks
    });
  }

  }

  public setOrderlinesForPlanningBlock(pbOrderlines: OrderLine[]) {
    this.ngRedux.dispatch({
      type: ActionKeys.SET_ORDERLINES_FOR_PLANNINGBLOCK,
      pbOrderlines
    })
  }

  public storeOrderlinesForPb(pbs: PlanningBlock[]) {
    if(pbs && pbs.length > 0) 
    {
    this.pbService.getPlanningBlockDetailsByIDs(pbs.map(pb => pb.id).join(',')).subscribe((data) => {
        this.setOrderlinesForPlanningBlock(data);
    })
  }
}

  public updatePbOrderLineSessionColumns(columns: Column[]) {
    this.ngRedux.dispatch({
        type: ActionKeys.UPDATE_PBORDERLINE_SESSION_COLUMNS,
        columns: columns
    })
  }



  public storedDataForShippingRail(lineNumbers) {

    this.pbService.getShippingRailDiaryByLineNumbers(lineNumbers).subscribe((data) => {

      this.ngRedux.dispatch({
        type: ActionKeys.SET_SHIPPING_RAIL_DATA,
        shippingRailDiary : data 
      });
    })
  }

  public async checkRelatedCoupleOrderLines(selectedPlanningBlocks: PlanningBlock[], onCancel?: () => void): Promise<boolean> {
    const appState = this.ngRedux.getState();
    const user = appState.applicationUser;

    if (!user || !user.generalSetting || !user.generalSetting.considerRelatedCoupleOrderLines) {
      return true; // Continue if feature is disabled
    }

    for (const pb of selectedPlanningBlocks) {
      if (pb.relatedCoupleOrderLineIds && pb.relatedCoupleOrderLineIds != "") {
        const relatedCoupleOrderLines = pb.relatedCoupleOrderLineIds.split(",").filter(id => id.trim() !== "");

        if (relatedCoupleOrderLines.length > 0) {
          try {
            const relatedPbs = await this.pbService.getPlanningBlocksForOrderLineIdsAsync(relatedCoupleOrderLines);

            if (relatedPbs && relatedPbs.length > 0) {
              // Check if any related planning blocks are not in the selected planning blocks
              const missingPbs = relatedPbs.filter(relatedPb =>
                !selectedPlanningBlocks.some(selectedPb => selectedPb.id === relatedPb.id)
              );

              if (missingPbs.length > 0) {
                // Return a promise that resolves when user confirms/cancels
                // The delay allows any pending operations to complete first
                return new Promise<boolean>((resolve) => {
                  const headerKey = "SHARED.PLAN_RELATED_PLANNING_BLOCKS.WARNING_MESSAGE";
                  const orderNumberKey = "SHARED.PLAN_RELATED_PLANNING_BLOCKS.ORDER_NUMBER";
                  const pbInfoKey = "SHARED.PLAN_RELATED_PLANNING_BLOCKS.PB_INFO";
                  
                  this.translate.get([headerKey, orderNumberKey, pbInfoKey]).subscribe(translations => {
                    let message = translations[headerKey] + "\n\n";

                    missingPbs.forEach((relatedPb, index) => {
                      const orderNumber = translations[orderNumberKey] || "Order Number";
                      const pbInfo = translations[pbInfoKey] || "Pb Info";
                      message += `${index + 1}. ${orderNumber}: ${relatedPb.orderNumber || 'N/A'}, ${pbInfo}: ${relatedPb.info || 'N/A'}`;
                      if (index < missingPbs.length - 1) {
                        message += '\n';
                      }
                    });

                        this.confirmDialogService.confirmThis(
                          message,
                          () => {
                            // Plan grouped: add the related planning blocks to the active selection.
                            missingPbs.forEach(relatedPb => {
                              if (!selectedPlanningBlocks.some(selectedPb => selectedPb.id === relatedPb.id)) {
                                selectedPlanningBlocks.push(relatedPb);
                              }
                            });
                            // Don't update the store here - let the component handle it
                            resolve(true);
                          },
                          () => {
                            // User cancelled - call onCancel callback if provided
                            if (onCancel) {
                              onCancel();
                            }
                            resolve(false);
                          },
                          {
                            confirmButtonTextTranslationKey: "SHARED.PLAN_RELATED_PLANNING_BLOCKS.PLAN_GROUPED",
                            thirdButtonTextTranslationKey: "SHARED.PLAN_RELATED_PLANNING_BLOCKS.PLAN_SELECTED",
                            thirdButtonClass: "btn btn-info",
                            thirdFn: () => {
                              // Plan selected: continue without adding related planning blocks.
                              resolve(true);
                            }
                          }
                        );
                      });
                    
                 
                });
              }
            }
          } catch (error) {
            // Handle error silently or log it
            console.error('Error fetching related planning blocks:', error);
          }
        }
      }
    }
    return true; // No related blocks found or no confirmation needed
  }

}
